import { render, staticRenderFns } from "./newPageClassList.vue?vue&type=template&id=cea1ebea&scoped=true"
import script from "./newPageClassList.vue?vue&type=script&lang=js"
export * from "./newPageClassList.vue?vue&type=script&lang=js"
import style0 from "./newPageClassList.vue?vue&type=style&index=0&id=cea1ebea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea1ebea",
  null
  
)

export default component.exports